enum ResourceTypes {
    AdditionalResources = 1,
    Maps = 2
}

export class ResourceTypesEnum_class {
    public static enum = ResourceTypes;

    public static readonly enumByText: {[key: string]: number} = {
        'Additional Resources': 1,
        'Maps': 2
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'Additional Resources',
        2: 'Maps'
    }
}